export default __webpack_public_path__ + "styles/MainAnalysisDetails.f3e73464d7acc03a10a2e47ab15894b8.css";